export default class NMEAFormatter {
  /**
   * @private
   */
  getTime(date) {
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();

    return '' + (hours < 10 ? '0' + hours : hours) + (minutes < 10 ? '0' + minutes : minutes) + (seconds < 10 ? '0' + seconds : seconds);
  }

  format(coordinate) {
    const wgs84 = coordinate.toWGS84();
    const timestamp = new Date();

    const time = this.getTime(timestamp);
    const date = this.getDateDayFirst(timestamp);
    const lat = this.getDegreeMinutesSeconds(wgs84.getY(), 'latitude');
    const lon = this.getDegreeMinutesSeconds(wgs84.getX(), 'longitude');

    const rmc = 'GPRMC,' + time + ',A,' + lat + ',' + lon + ',,,' + date + ',,,A';

    return '$' + rmc + '*' + this.getChecksum(rmc);
  }

  /**
   * @private
   */
  getDateDayFirst(date) {
    let year = date.getUTCFullYear();
    let month = date.getUTCMonth() + 1;
    let day = date.getUTCDate();

    return '' + (day < 10 ? '0' + day : day) + (month < 10 ? '0' + month : month) + (year % 100);
  }

  /**
   * @private
   */
  getDegreeMinutesSeconds(degreesDecimal, mode) {
    const negative = degreesDecimal < 0;
    degreesDecimal = Math.abs(degreesDecimal);

    const degrees = Math.floor(degreesDecimal);
    let remainder = degreesDecimal - degrees;

    const minutes = Math.floor(60 * remainder);
    remainder = (60 * remainder) - minutes; // 60 * remainder is the decimal value for minutes and seconds

    const s = Math.floor(remainder * 10000);
    const minuteFraction = s < 10 ? '000' + s : s < 100 ? '00' + s : s < 1000 ? '0' + s : '' + s;

    let hemisphere;

    if (mode === 'latitude') {
      // return XXYY.ZZZZ,b which is XXºYY'ZZZZ'' with being N or S
      hemisphere = negative ? 'S' : 'N';
      return this.toTwoPlaces(degrees) + this.toTwoPlaces(minutes) + '.' + minuteFraction + ',' + hemisphere;
    }

    // return XXXYY.ZZZZ,l which is XXºYY'ZZZZ'' with l being W or E
    hemisphere = negative ? 'W' : 'E';
    return this.toThreePlaces(degrees) + this.toTwoPlaces(minutes) + '.' + minuteFraction + ',' + hemisphere;
  }

  /**
   * @private
   */
  toTwoPlaces(n) {
    if (n < 10) return '0' + n;

    return n.toString();
  }

  /**
   * @private
   */
  toThreePlaces(n) {
    if (n < 10) return '00' + n;
    if (n < 100) return '0' + n;

    return n.toString();
  }

  /**
   * Returns the bitwise XOR of the ASCII codes in the specified string (as a hexadecimal number).
   * @private
   */
  getChecksum(s) {
    let checksum = 0;

    for (let i = 0; i < s.length; i++) {
      checksum ^= s.charCodeAt(i);
    }

    return checksum.toString(16).toUpperCase();
  }
}

module.exports = NMEAFormatter;
